/* MAC — JS bundle: Three.js scenes, globe, app logic */
/* Inlined as a snippet tag from sections */

(function () {
  /* ── Reveal observer ── */
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('mac-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });
  document.querySelectorAll('.mac-reveal, .mac-steps').forEach(el => io.observe(el));

  /* ── Count-up ── */
  const cio = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target;
      const target = parseFloat(el.dataset.macTo);
      const dec = parseInt(el.dataset.macDec || '0', 10);
      const dur = 1400, t0 = performance.now();
      function step(now) {
        const t = Math.min(1, (now - t0) / dur);
        const eased = 1 - Math.pow(1 - t, 3);
        el.textContent = dec ? (target * eased).toFixed(dec) : Math.round(target * eased).toLocaleString();
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      cio.unobserve(el);
    });
  }, { threshold: 0.6 });
  document.querySelectorAll('[data-mac-to]').forEach(el => cio.observe(el));

  /* ── ECG path ── */
  function buildEcg(width, height, beats) {
    const b = height * 0.55; let d = `M 0 ${b}`;
    for (let i = 0; i < beats; i++) {
      const x0 = i * (width / beats), s = width / beats;
      d += ` L ${x0+s*.10} ${b} Q ${x0+s*.14} ${b-6} ${x0+s*.18} ${b}`;
      d += ` L ${x0+s*.26} ${b} L ${x0+s*.30} ${b+6} L ${x0+s*.34} ${b-height*.65}`;
      d += ` L ${x0+s*.38} ${b+14} L ${x0+s*.42} ${b}`;
      d += ` L ${x0+s*.55} ${b} Q ${x0+s*.62} ${b-10} ${x0+s*.70} ${b} L ${x0+s} ${b}`;
    }
    return d;
  }
  document.querySelectorAll('.mac-ecg-svg').forEach(svg => {
    const w = svg.clientWidth || 600, h = 56;
    svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
    const d = buildEcg(w, h, 3);
    svg.querySelectorAll('path').forEach(p => p.setAttribute('d', d));
  });

  /* ── Sparklines ── */
  document.querySelectorAll('.mac-trend').forEach(svg => {
    const w = svg.clientWidth || 100, h = 24;
    svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
    let d = '';
    for (let i = 0; i < 14; i++) {
      const x = (i / 13) * w, y = h*.5 + (Math.sin(i*1.1+Math.random()) + (Math.random()-.5))*4;
      d += (i===0 ? `M ${x} ${y}` : ` L ${x.toFixed(1)} ${y.toFixed(1)}`);
    }
    svg.querySelector('path').setAttribute('d', d);
  });

  /* ── Step connector ── */
  document.querySelectorAll('.mac-steps-line svg').forEach(svg => {
    const w = svg.parentElement.clientWidth || 800;
    svg.setAttribute('viewBox', `0 0 ${w} 1`);
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.querySelector('path').setAttribute('d', `M 0 0.5 L ${w} 0.5`);
  });

  /* ── Boot Three.js scenes ── */
  function boot3D() {
    if (!window.MAC3D) { setTimeout(boot3D, 60); return; }
    const heroC = document.getElementById('mac-hero-canvas');
    if (heroC) MAC3D.heroScene(heroC);
    const crossC = document.getElementById('mac-cross-canvas');
    if (crossC) MAC3D.crossScene(crossC);
    const cardC = document.getElementById('mac-tech-canvas');
    if (cardC) MAC3D.cardScene(cardC);
    const globeC = document.getElementById('mac-globe-canvas');
    if (globeC && window.MAC_GLOBE) MAC_GLOBE(globeC);
  }
  if (document.readyState === 'complete' || document.readyState === 'interactive') setTimeout(boot3D, 50);
  else window.addEventListener('DOMContentLoaded', () => setTimeout(boot3D, 50));
})();

/* ────────────────────────────────────────────────
   Three.js Scenes (r128)
   ──────────────────────────────────────────────── */
(function () {
  if (typeof THREE === 'undefined') return;
  const TEAL = 0x5cc6e8;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function heroScene(canvas) {
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(60, 1, 0.1, 200);
    camera.position.set(0, 0, 30);
    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    const COUNT = 700, W = 90, H = 60, D = 50;
    const positions = new Float32Array(COUNT * 3);
    const speeds = new Float32Array(COUNT), drifts = new Float32Array(COUNT);
    const phases = new Float32Array(COUNT), sizes = new Float32Array(COUNT), opacities = new Float32Array(COUNT);
    for (let i = 0; i < COUNT; i++) {
      positions[i*3] = (Math.random()-.5)*W; positions[i*3+1] = (Math.random()-.5)*H; positions[i*3+2] = (Math.random()-.5)*D;
      speeds[i] = .008+Math.random()*.022; drifts[i] = (Math.random()-.5)*.004;
      phases[i] = Math.random()*Math.PI*2; sizes[i] = .6+Math.random()*1.6; opacities[i] = .15+Math.random()*.10;
    }
    const geo = new THREE.BufferGeometry();
    geo.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    geo.setAttribute('aSize', new THREE.BufferAttribute(sizes, 1));
    geo.setAttribute('aOpacity', new THREE.BufferAttribute(opacities, 1));
    const c = document.createElement('canvas'); c.width = c.height = 64;
    const cx = c.getContext('2d');
    const grad = cx.createRadialGradient(32,32,0,32,32,32);
    grad.addColorStop(0,'rgba(255,255,255,1)'); grad.addColorStop(.4,'rgba(255,255,255,.7)'); grad.addColorStop(1,'rgba(255,255,255,0)');
    cx.fillStyle = grad; cx.fillRect(0,0,64,64);
    const tex = new THREE.CanvasTexture(c);
    const material = new THREE.ShaderMaterial({
      uniforms: { uTex: { value: tex }, uPxRatio: { value: renderer.getPixelRatio() } },
      vertexShader: `attribute float aSize; attribute float aOpacity; varying float vOpacity; uniform float uPxRatio;
        void main() { vOpacity=aOpacity; vec4 mv=modelViewMatrix*vec4(position,1.0); gl_PointSize=aSize*(300.0/-mv.z)*uPxRatio; gl_Position=projectionMatrix*mv; }`,
      fragmentShader: `uniform sampler2D uTex; varying float vOpacity;
        void main() { vec4 t=texture2D(uTex,gl_PointCoord); gl_FragColor=vec4(0.361,0.776,0.910,t.a*vOpacity); }`,
      transparent: true, depthWrite: false, blending: THREE.NormalBlending,
    });
    const points = new THREE.Points(geo, material);
    scene.add(points);
    let mouseX=0, mouseY=0, targetX=0, targetY=0;
    window.addEventListener('mousemove', e => { targetX=(e.clientX/window.innerWidth-.5); targetY=(e.clientY/window.innerHeight-.5); }, { passive: true });
    function resize() {
      const rect = canvas.parentElement.getBoundingClientRect();
      camera.aspect = rect.width / Math.max(1, rect.height);
      camera.updateProjectionMatrix();
      renderer.setSize(rect.width, rect.height, false);
      material.uniforms.uPxRatio.value = renderer.getPixelRatio();
    }
    resize(); new ResizeObserver(resize).observe(canvas.parentElement);
    function tick(t) {
      const pos = geo.attributes.position.array, time = t*.001;
      for (let i = 0; i < COUNT; i++) {
        pos[i*3+1] += speeds[i]; pos[i*3] += Math.sin(time*.3+phases[i])*.006+drifts[i];
        if (pos[i*3+1] > H/2) pos[i*3+1]=-H/2;
        if (pos[i*3] > W/2) pos[i*3]=-W/2; if (pos[i*3] < -W/2) pos[i*3]=W/2;
      }
      geo.attributes.position.needsUpdate = true;
      mouseX += (targetX-mouseX)*.04; mouseY += (targetY-mouseY)*.04;
      points.position.x = mouseX*4; points.position.y = -mouseY*2.5;
      renderer.render(scene, camera); requestAnimationFrame(tick);
    }
    if (!reduced) tick(0); else renderer.render(scene, camera);
  }

  function crossScene(canvas) {
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(40, 1, 0.1, 50);
    camera.position.set(0, 0, 4.6);
    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(canvas.clientWidth, canvas.clientHeight, false);
    const g = new THREE.Group();
    const mat = new THREE.MeshBasicMaterial({ color: TEAL });
    const cross = new THREE.Group();
    cross.add(new THREE.Mesh(new THREE.BoxGeometry(2.0,.7,.7), mat));
    cross.add(new THREE.Mesh(new THREE.BoxGeometry(.7,2.0,.7), mat));
    const wireMat = new THREE.LineBasicMaterial({ color: 0xffffff, transparent: true, opacity: .28 });
    [new THREE.BoxGeometry(2.0,.7,.7), new THREE.BoxGeometry(.7,2.0,.7)].forEach(geo => {
      cross.add(new THREE.LineSegments(new THREE.EdgesGeometry(geo), wireMat));
    });
    g.add(cross); scene.add(g);
    function resize() { renderer.setSize(canvas.clientWidth, canvas.clientHeight, false); }
    new ResizeObserver(resize).observe(canvas);
    function tick() { cross.rotation.y+=.008; cross.rotation.x+=.0035; renderer.render(scene, camera); requestAnimationFrame(tick); }
    if (!reduced) tick(); else renderer.render(scene, camera);
  }

  function cardScene(canvas) {
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(38, 1, 0.1, 50);
    camera.position.set(0, 0, 6);
    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    const g = new THREE.Group();
    const shape = new THREE.Shape();
    const w=2.6, h=3.6, r=.22;
    shape.moveTo(-w/2+r,-h/2); shape.lineTo(w/2-r,-h/2); shape.quadraticCurveTo(w/2,-h/2,w/2,-h/2+r);
    shape.lineTo(w/2,h/2-r); shape.quadraticCurveTo(w/2,h/2,w/2-r,h/2);
    shape.lineTo(-w/2+r,h/2); shape.quadraticCurveTo(-w/2,h/2,-w/2,h/2-r);
    shape.lineTo(-w/2,-h/2+r); shape.quadraticCurveTo(-w/2,-h/2,-w/2+r,-h/2);
    const cardGeo = new THREE.ExtrudeGeometry(shape, { depth:.08, bevelEnabled:true, bevelSegments:4, bevelSize:.03, bevelThickness:.03 });
    cardGeo.center();
    g.add(new THREE.Mesh(cardGeo, new THREE.MeshBasicMaterial({ color: 0x2a2a2a, transparent: true, opacity: .92 })));
    g.add(new THREE.LineSegments(new THREE.EdgesGeometry(cardGeo, 30), new THREE.LineBasicMaterial({ color: TEAL, transparent: true, opacity: .7 })));
    const lineMat = new THREE.LineBasicMaterial({ color: TEAL, transparent: true, opacity: .55 });
    const lineMatDim = new THREE.LineBasicMaterial({ color: 0xffffff, transparent: true, opacity: .18 });
    function ln(x1,y1,x2,y2,mat=lineMatDim) {
      g.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints([new THREE.Vector3(x1,y1,.05),new THREE.Vector3(x2,y2,.05)]), mat));
    }
    ln(-1.0,1.4,1.0,1.4,lineMat); ln(-1.0,1.2,0.4,1.2);
    const pts = [];
    for (let i=0; i<=24; i++) pts.push(new THREE.Vector3(-1.05+(i/24)*2.1, .2+Math.sin(i*.4)*.3+(i/24)*.5, .05));
    g.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints(pts), lineMat));
    for (let i=0; i<4; i++) ln(-1.05,-.7-i*.3,.4+Math.random()*.6,-.7-i*.3);
    scene.add(g);
    function resize() { const cw=canvas.clientWidth, ch=canvas.clientHeight; camera.aspect=cw/Math.max(1,ch); camera.updateProjectionMatrix(); renderer.setSize(cw,ch,false); }
    resize(); new ResizeObserver(resize).observe(canvas);
    function tick(t) { g.rotation.y=Math.sin(t*.0003)*.55-.15; g.rotation.x=Math.sin(t*.0002)*.08; g.position.y=Math.sin(t*.0005)*.06; renderer.render(scene,camera); requestAnimationFrame(tick); }
    if (!reduced) tick(0); else renderer.render(scene, camera);
  }

  window.MAC3D = { heroScene, crossScene, cardScene };
})();

/* ────────────────────────────────────────────────
   Globe (Three.js r128)
   ──────────────────────────────────────────────── */
(function () {
  if (typeof THREE === 'undefined') return;
  function init(canvas) {
    const TEAL = 0x5cc6e8;
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(35, 1, 0.1, 100);
    camera.position.set(0, 0, 6);
    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    const root = new THREE.Group(); scene.add(root);
    const R = 1.6;
    root.add(new THREE.Mesh(new THREE.SphereGeometry(R,64,64), new THREE.MeshBasicMaterial({ color: 0x0a1628 })));
    const gridMat = new THREE.LineBasicMaterial({ color: TEAL, transparent: true, opacity: .15 });
    for (let lat=-75; lat<=75; lat+=15) {
      const phi=(90-lat)*Math.PI/180; const pts=[];
      for (let lng=0; lng<=360; lng+=4) { const t=lng*Math.PI/180; pts.push(new THREE.Vector3(R*Math.sin(phi)*Math.cos(t),R*Math.cos(phi),R*Math.sin(phi)*Math.sin(t))); }
      root.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints(pts), gridMat));
    }
    for (let lng=0; lng<360; lng+=15) {
      const theta=lng*Math.PI/180; const pts=[];
      for (let lat=-90; lat<=90; lat+=4) { const phi=(90-lat)*Math.PI/180; pts.push(new THREE.Vector3(R*Math.sin(phi)*Math.cos(theta),R*Math.cos(phi),R*Math.sin(phi)*Math.sin(theta))); }
      root.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints(pts), gridMat));
    }
    const dp=[]; for (let i=0; i<1400; i++) { const u=Math.random(),v=Math.random(); const phi=Math.acos(2*v-1),theta=2*Math.PI*u,r=R*1.005; dp.push(r*Math.sin(phi)*Math.cos(theta),r*Math.cos(phi),r*Math.sin(phi)*Math.sin(theta)); }
    const dg=new THREE.BufferGeometry(); dg.setAttribute('position',new THREE.Float32BufferAttribute(dp,3));
    root.add(new THREE.Points(dg, new THREE.PointsMaterial({ color:TEAL, size:.018, transparent:true, opacity:.45 })));
    function lv(lat,lng,rad=R*1.01) { const phi=(90-lat)*Math.PI/180,theta=(lng+180)*Math.PI/180; return new THREE.Vector3(-rad*Math.sin(phi)*Math.cos(theta),rad*Math.cos(phi),rad*Math.sin(phi)*Math.sin(theta)); }
    const lebanon={lat:33.8,lng:35.8};
    const targets=[{lat:35.1,lng:33.4},{lat:24.4,lng:54.3},{lat:24.7,lng:46.7},{lat:31.9,lng:35.9},{lat:30.0,lng:31.2}];
    const pinV=lv(lebanon.lat,lebanon.lng,R*1.02);
    root.add(new THREE.Mesh(new THREE.SphereGeometry(.05,24,24), new THREE.MeshBasicMaterial({ color:TEAL })));
    root.children[root.children.length-1].position.copy(pinV);
    const halos=[];
    for (let i=0; i<2; i++) { const h=new THREE.Mesh(new THREE.RingGeometry(.06,.07,48), new THREE.MeshBasicMaterial({ color:TEAL, transparent:true, opacity:.6, side:THREE.DoubleSide })); h.position.copy(pinV); h.lookAt(0,0,0); h.rotateY(Math.PI); h.userData.phase=i*.5; root.add(h); halos.push(h); }
    const beams=[];
    targets.forEach((t,idx) => {
      const a=lv(lebanon.lat,lebanon.lng,R*1.02), b=lv(t.lat,t.lng,R*1.02);
      const mid=a.clone().add(b).multiplyScalar(.5).normalize().multiplyScalar(R*1.45);
      const curve=new THREE.QuadraticBezierCurve3(a,mid,b);
      root.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints(curve.getPoints(60)), new THREE.LineBasicMaterial({ color:TEAL, transparent:true, opacity:.45 })));
      const dot=new THREE.Mesh(new THREE.SphereGeometry(.035,16,16), new THREE.MeshBasicMaterial({ color:TEAL })); dot.position.copy(b); root.add(dot);
      const tr=new THREE.Mesh(new THREE.SphereGeometry(.035,16,16), new THREE.MeshBasicMaterial({ color:0xffffff, transparent:true })); root.add(tr);
      beams.push({ curve, traveller:tr, phase:idx*.2 });
    });
    let dragging=false, lastX=0, lastY=0, velY=0, velX=0, userTilt=0;
    canvas.addEventListener('mousedown', e=>{dragging=true;lastX=e.clientX;lastY=e.clientY;});
    window.addEventListener('mousemove', e=>{if(!dragging)return;const dx=e.clientX-lastX,dy=e.clientY-lastY;lastX=e.clientX;lastY=e.clientY;velY=dx*.005;velX=dy*.003;root.rotation.y+=velY;userTilt=Math.max(-.7,Math.min(.7,userTilt+velX));root.rotation.x=userTilt;});
    window.addEventListener('mouseup', ()=>dragging=false);
    canvas.addEventListener('touchstart', e=>{dragging=true;lastX=e.touches[0].clientX;lastY=e.touches[0].clientY;},{passive:true});
    window.addEventListener('touchmove', e=>{if(!dragging)return;const dx=e.touches[0].clientX-lastX,dy=e.touches[0].clientY-lastY;lastX=e.touches[0].clientX;lastY=e.touches[0].clientY;velY=dx*.005;root.rotation.y+=velY;},{passive:true});
    window.addEventListener('touchend', ()=>dragging=false);
    root.rotation.y=-1.0; userTilt=-0.15; root.rotation.x=userTilt;
    function resize() { const w=canvas.clientWidth,h=canvas.clientHeight; camera.aspect=w/Math.max(1,h); camera.updateProjectionMatrix(); renderer.setSize(w,h,false); }
    resize(); new ResizeObserver(resize).observe(canvas);
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function tick(t) {
      if(!dragging){root.rotation.y+=.0015;velY*=.94;}
      halos.forEach(h=>{ const phase=(t*.001+h.userData.phase)%1.6,s=1+phase*3; h.scale.set(s,s,s); h.material.opacity=Math.max(0,.7-phase/1.6*.7); });
      beams.forEach(b=>{ const u=((t*.0005)+b.phase)%1,p=b.curve.getPoint(u); b.traveller.position.copy(p); b.traveller.material.opacity=Math.sin(u*Math.PI); });
      renderer.render(scene,camera); requestAnimationFrame(tick);
    }
    if (!reduced) tick(0); else renderer.render(scene, camera);
  }
  window.MAC_GLOBE = init;
})();
